var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 215,
    viewBox: "0 0 238 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7774 184.826L35.2564 186.685L27.8781 188.113L19.5607 186.133L27.7774 184.826Z",
    fill: "url(#paint0_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7774 184.826L35.2564 186.685L27.8781 188.113L19.5607 186.133L27.7774 184.826Z",
    fill: "url(#paint1_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7774 184.826L35.2564 186.685L27.8781 188.113L19.5607 186.133L27.7774 184.826Z",
    fill: "url(#paint2_linear_201_600)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5272 186.119L27.9788 188.086V214.049L19.5272 211.597V186.119Z",
    fill: "url(#paint3_linear_201_600)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5807 211.557V186.187L27.9253 188.129V213.978L19.5807 211.557Z",
    stroke: "url(#paint4_linear_201_600)",
    strokeWidth: 0.10692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5807 211.557V186.187L27.9253 188.129V213.978L19.5807 211.557Z",
    stroke: "url(#paint5_radial_201_600)",
    strokeWidth: 0.10692
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2564 186.685L27.9787 188.086V214.049L35.2564 212.396V186.685Z",
    fill: "url(#paint6_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2564 186.685L27.9787 188.086V214.049L35.2564 212.396V186.685Z",
    fill: "url(#paint7_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2029 212.354V186.75L28.0321 188.13V213.982L35.2029 212.354Z",
    stroke: "url(#paint8_linear_201_600)",
    strokeWidth: 0.10692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2029 212.354V186.75L28.0321 188.13V213.982L35.2029 212.354Z",
    stroke: "url(#paint9_radial_201_600)",
    strokeWidth: 0.10692
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9766 94.1365L55.2441 100.667L29.33 105.682L0.117736 98.7265L28.9766 94.1365Z",
    fill: "url(#paint10_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9766 94.1365L55.2441 100.667L29.33 105.682L0.117736 98.7265L28.9766 94.1365Z",
    fill: "url(#paint11_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9766 94.1365L55.2441 100.667L29.33 105.682L0.117736 98.7265L28.9766 94.1365Z",
    fill: "url(#paint12_linear_201_600)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.90735e-05 98.6791L29.6834 105.588V196.775L-1.90735e-05 188.162V98.6791Z",
    fill: "url(#paint13_linear_201_600)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.187743 188.021V98.9156L29.4957 105.737V196.525L0.187743 188.021Z",
    stroke: "url(#paint14_linear_201_600)",
    strokeWidth: 0.375525
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.187743 188.021V98.9156L29.4957 105.737V196.525L0.187743 188.021Z",
    stroke: "url(#paint15_radial_201_600)",
    strokeWidth: 0.375525
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.2441 100.667L29.6834 105.588V196.775L55.2441 190.97V100.667Z",
    fill: "url(#paint16_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2441 100.667L29.6834 105.588V196.775L55.2441 190.97V100.667Z",
    fill: "url(#paint17_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0564 190.82V100.894L29.8712 105.743V196.54L55.0564 190.82Z",
    stroke: "url(#paint18_linear_201_600)",
    strokeWidth: 0.375525
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0564 190.82V100.894L29.8712 105.743V196.54L55.0564 190.82Z",
    stroke: "url(#paint19_radial_201_600)",
    strokeWidth: 0.375525
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7774 72.9194L35.2564 74.7786L27.8781 76.2067L19.5607 74.2263L27.7774 72.9194Z",
    fill: "url(#paint20_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7774 72.9194L35.2564 74.7786L27.8781 76.2067L19.5607 74.2263L27.7774 72.9194Z",
    fill: "url(#paint21_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7774 72.9194L35.2564 74.7786L27.8781 76.2067L19.5607 74.2263L27.7774 72.9194Z",
    fill: "url(#paint22_linear_201_600)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5272 74.2128L27.9788 76.1798V102.143L19.5272 99.6906V74.2128Z",
    fill: "url(#paint23_linear_201_600)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5807 99.6505V74.2801L27.9253 76.2222V102.072L19.5807 99.6505Z",
    stroke: "url(#paint24_linear_201_600)",
    strokeWidth: 0.10692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5807 99.6505V74.2801L27.9253 76.2222V102.072L19.5807 99.6505Z",
    stroke: "url(#paint25_radial_201_600)",
    strokeWidth: 0.10692
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2564 74.7788L27.9787 76.1799V102.143L35.2564 100.49V74.7788Z",
    fill: "url(#paint26_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2564 74.7788L27.9787 76.1799V102.143L35.2564 100.49V74.7788Z",
    fill: "url(#paint27_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2029 100.447V74.8435L28.0321 76.2241V102.076L35.2029 100.447Z",
    stroke: "url(#paint28_linear_201_600)",
    strokeWidth: 0.10692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2029 100.447V74.8435L28.0321 76.2241V102.076L35.2029 100.447Z",
    stroke: "url(#paint29_radial_201_600)",
    strokeWidth: 0.10692
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.282 152.993L175.761 154.852L168.383 156.28L160.065 154.3L168.282 152.993Z",
    fill: "url(#paint30_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.282 152.993L175.761 154.852L168.383 156.28L160.065 154.3L168.282 152.993Z",
    fill: "url(#paint31_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.282 152.993L175.761 154.852L168.383 156.28L160.065 154.3L168.282 152.993Z",
    fill: "url(#paint32_linear_201_600)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.032 154.286L168.483 156.253V182.216L160.032 179.764V154.286Z",
    fill: "url(#paint33_linear_201_600)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.085 179.724V154.354L168.43 156.296V182.145L160.085 179.724Z",
    stroke: "url(#paint34_linear_201_600)",
    strokeWidth: 0.10692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.085 179.724V154.354L168.43 156.296V182.145L160.085 179.724Z",
    stroke: "url(#paint35_radial_201_600)",
    strokeWidth: 0.10692
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.761 154.852L168.483 156.253V182.216L175.761 180.563V154.852Z",
    fill: "url(#paint36_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.761 154.852L168.483 156.253V182.216L175.761 180.563V154.852Z",
    fill: "url(#paint37_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.707 180.52V154.917L168.536 156.297V182.149L175.707 180.52Z",
    stroke: "url(#paint38_linear_201_600)",
    strokeWidth: 0.10692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.707 180.52V154.917L168.536 156.297V182.149L175.707 180.52Z",
    stroke: "url(#paint39_radial_201_600)",
    strokeWidth: 0.10692
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.481 62.3037L195.748 68.8337L169.834 73.8495L140.622 66.8936L169.481 62.3037Z",
    fill: "url(#paint40_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.481 62.3037L195.748 68.8337L169.834 73.8495L140.622 66.8936L169.481 62.3037Z",
    fill: "url(#paint41_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.481 62.3037L195.748 68.8337L169.834 73.8495L140.622 66.8936L169.481 62.3037Z",
    fill: "url(#paint42_linear_201_600)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.504 66.8463L170.188 73.7548V164.942L140.504 156.33V66.8463Z",
    fill: "url(#paint43_linear_201_600)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.692 156.189V67.0828L170 73.9039V164.692L140.692 156.189Z",
    stroke: "url(#paint44_linear_201_600)",
    strokeWidth: 0.375525
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.692 156.189V67.0828L170 73.9039V164.692L140.692 156.189Z",
    stroke: "url(#paint45_radial_201_600)",
    strokeWidth: 0.375525
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.748 68.8337L170.187 73.7549V164.942L195.748 159.137V68.8337Z",
    fill: "url(#paint46_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.748 68.8337L170.187 73.7549V164.942L195.748 159.137V68.8337Z",
    fill: "url(#paint47_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.56 158.987V69.0611L170.375 73.9099V164.707L195.56 158.987Z",
    stroke: "url(#paint48_linear_201_600)",
    strokeWidth: 0.375525
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.56 158.987V69.0611L170.375 73.9099V164.707L195.56 158.987Z",
    stroke: "url(#paint49_radial_201_600)",
    strokeWidth: 0.375525
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.282 41.0863L175.761 42.9456L168.383 44.3737L160.065 42.3932L168.282 41.0863Z",
    fill: "url(#paint50_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.282 41.0863L175.761 42.9456L168.383 44.3737L160.065 42.3932L168.282 41.0863Z",
    fill: "url(#paint51_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.282 41.0863L175.761 42.9456L168.383 44.3737L160.065 42.3932L168.282 41.0863Z",
    fill: "url(#paint52_linear_201_600)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.032 42.3797L168.483 44.3467V70.3097L160.032 67.8575V42.3797Z",
    fill: "url(#paint53_linear_201_600)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.085 67.8174V42.447L168.43 44.3892V70.2386L160.085 67.8174Z",
    stroke: "url(#paint54_linear_201_600)",
    strokeWidth: 0.10692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.085 67.8174V42.447L168.43 44.3892V70.2386L160.085 67.8174Z",
    stroke: "url(#paint55_radial_201_600)",
    strokeWidth: 0.10692
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.761 42.9457L168.483 44.3468V70.3099L175.761 68.6569V42.9457Z",
    fill: "url(#paint56_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.761 42.9457L168.483 44.3468V70.3099L175.761 68.6569V42.9457Z",
    fill: "url(#paint57_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.707 68.6142V43.0104L168.536 44.391V70.2429L175.707 68.6142Z",
    stroke: "url(#paint58_linear_201_600)",
    strokeWidth: 0.10692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.707 68.6142V43.0104L168.536 44.391V70.2429L175.707 68.6142Z",
    stroke: "url(#paint59_radial_201_600)",
    strokeWidth: 0.10692
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.534 184.826L246.013 186.685L238.634 188.113L230.317 186.133L238.534 184.826Z",
    fill: "url(#paint60_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.534 184.826L246.013 186.685L238.634 188.113L230.317 186.133L238.534 184.826Z",
    fill: "url(#paint61_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.534 184.826L246.013 186.685L238.634 188.113L230.317 186.133L238.534 184.826Z",
    fill: "url(#paint62_linear_201_600)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.283 186.119L238.735 188.086V214.049L230.283 211.597V186.119Z",
    fill: "url(#paint63_linear_201_600)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.337 211.557V186.187L238.681 188.129V213.978L230.337 211.557Z",
    stroke: "url(#paint64_linear_201_600)",
    strokeWidth: 0.10692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.337 211.557V186.187L238.681 188.129V213.978L230.337 211.557Z",
    stroke: "url(#paint65_radial_201_600)",
    strokeWidth: 0.10692
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.733 39.2521L266 45.7821L240.086 50.7979L210.874 43.842L239.733 39.2521Z",
    fill: "url(#paint66_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.733 39.2521L266 45.7821L240.086 50.7979L210.874 43.842L239.733 39.2521Z",
    fill: "url(#paint67_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.733 39.2521L266 45.7821L240.086 50.7979L210.874 43.842L239.733 39.2521Z",
    fill: "url(#paint68_linear_201_600)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.756 43.7947L240.439 50.7032V196.775L210.756 188.162V43.7947Z",
    fill: "url(#paint69_linear_201_600)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.944 188.021V44.0312L240.252 50.8523V196.525L210.944 188.021Z",
    stroke: "url(#paint70_linear_201_600)",
    strokeWidth: 0.375525
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.944 188.021V44.0312L240.252 50.8523V196.525L210.944 188.021Z",
    stroke: "url(#paint71_radial_201_600)",
    strokeWidth: 0.375525
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.534 18.0349L246.013 19.8942L238.634 21.3223L230.317 19.3418L238.534 18.0349Z",
    fill: "url(#paint72_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.534 18.0349L246.013 19.8942L238.634 21.3223L230.317 19.3418L238.534 18.0349Z",
    fill: "url(#paint73_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.534 18.0349L246.013 19.8942L238.634 21.3223L230.317 19.3418L238.534 18.0349Z",
    fill: "url(#paint74_linear_201_600)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.283 19.3283L238.735 21.2953V47.2583L230.283 44.8062V19.3283Z",
    fill: "url(#paint75_linear_201_600)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.337 44.766V19.3956L238.681 21.3378V47.1872L230.337 44.766Z",
    stroke: "url(#paint76_linear_201_600)",
    strokeWidth: 0.10692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.337 44.766V19.3956L238.681 21.3378V47.1872L230.337 44.766Z",
    stroke: "url(#paint77_radial_201_600)",
    strokeWidth: 0.10692
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.0295 168.361L105.508 170.22L98.1301 171.648L89.8128 169.667L98.0295 168.361Z",
    fill: "url(#paint78_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0295 168.361L105.508 170.22L98.1301 171.648L89.8128 169.667L98.0295 168.361Z",
    fill: "url(#paint79_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0295 168.361L105.508 170.22L98.1301 171.648L89.8128 169.667L98.0295 168.361Z",
    fill: "url(#paint80_linear_201_600)"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7793 169.654L98.2308 171.621V197.584L89.7793 195.132V169.654Z",
    fill: "url(#paint81_linear_201_600)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8327 195.092V169.721L98.1774 171.663V197.513L89.8327 195.092Z",
    stroke: "url(#paint82_linear_201_600)",
    strokeWidth: 0.10692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8327 195.092V169.721L98.1774 171.663V197.513L89.8327 195.092Z",
    stroke: "url(#paint83_radial_201_600)",
    strokeWidth: 0.10692
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.508 170.22L98.2307 171.621V197.584L105.508 195.931V170.22Z",
    fill: "url(#paint84_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.508 170.22L98.2307 171.621V197.584L105.508 195.931V170.22Z",
    fill: "url(#paint85_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.455 195.888V170.284L98.2842 171.665V197.517L105.455 195.888Z",
    stroke: "url(#paint86_linear_201_600)",
    strokeWidth: 0.10692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.455 195.888V170.284L98.2842 171.665V197.517L105.455 195.888Z",
    stroke: "url(#paint87_radial_201_600)",
    strokeWidth: 0.10692
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.2287 22.7868L125.496 29.3168L99.5821 34.3326L70.3698 27.3767L99.2287 22.7868Z",
    fill: "url(#paint88_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2287 22.7868L125.496 29.3168L99.5821 34.3326L70.3698 27.3767L99.2287 22.7868Z",
    fill: "url(#paint89_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2287 22.7868L125.496 29.3168L99.5821 34.3326L70.3698 27.3767L99.2287 22.7868Z",
    fill: "url(#paint90_linear_201_600)"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.252 27.3294L99.9355 34.2379V180.31L70.252 171.697V27.3294Z",
    fill: "url(#paint91_linear_201_600)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4398 171.556V27.5659L99.7477 34.387V180.06L70.4398 171.556Z",
    stroke: "url(#paint92_linear_201_600)",
    strokeWidth: 0.375525
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4398 171.556V27.5659L99.7477 34.387V180.06L70.4398 171.556Z",
    stroke: "url(#paint93_radial_201_600)",
    strokeWidth: 0.375525
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.496 29.3168L99.9354 34.2379V180.31L125.496 174.504V29.3168Z",
    fill: "url(#paint94_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.496 29.3168L99.9354 34.2379V180.31L125.496 174.504V29.3168Z",
    fill: "url(#paint95_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.308 174.354V29.5441L100.123 34.393V180.074L125.308 174.354Z",
    stroke: "url(#paint96_linear_201_600)",
    strokeWidth: 0.375525
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.308 174.354V29.5441L100.123 34.393V180.074L125.308 174.354Z",
    stroke: "url(#paint97_radial_201_600)",
    strokeWidth: 0.375525
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.0295 1.56963L105.508 3.42887L98.1301 4.85698L89.8128 2.87649L98.0295 1.56963Z",
    fill: "url(#paint98_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0295 1.56963L105.508 3.42887L98.1301 4.85698L89.8128 2.87649L98.0295 1.56963Z",
    fill: "url(#paint99_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0295 1.56963L105.508 3.42887L98.1301 4.85698L89.8128 2.87649L98.0295 1.56963Z",
    fill: "url(#paint100_linear_201_600)"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7793 2.86298L98.2308 4.83V30.793L89.7793 28.3408V2.86298Z",
    fill: "url(#paint101_linear_201_600)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8327 28.3007V2.93031L98.1774 4.87244V30.7218L89.8327 28.3007Z",
    stroke: "url(#paint102_linear_201_600)",
    strokeWidth: 0.10692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8327 28.3007V2.93031L98.1774 4.87244V30.7218L89.8327 28.3007Z",
    stroke: "url(#paint103_radial_201_600)",
    strokeWidth: 0.10692
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_b_201_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.508 3.42902L98.2307 4.83018V30.7932L105.508 29.1403V3.42902Z",
    fill: "url(#paint104_linear_201_600)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.508 3.42902L98.2307 4.83018V30.7932L105.508 29.1403V3.42902Z",
    fill: "url(#paint105_linear_201_600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.455 29.0976V3.49375L98.2842 4.87433V30.7262L105.455 29.0976Z",
    stroke: "url(#paint106_linear_201_600)",
    strokeWidth: 0.10692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.455 29.0976V3.49375L98.2842 4.87433V30.7262L105.455 29.0976Z",
    stroke: "url(#paint107_radial_201_600)",
    strokeWidth: 0.10692
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_201_600",
    x: 18.2356,
    y: 183.501,
    width: 18.3458,
    height: 5.93748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.662531
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_201_600",
    x: 19.2851,
    y: 185.877,
    width: 8.93582,
    height: 28.4143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.121071
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_201_600",
    x: 27.7365,
    y: 186.443,
    width: 7.76199,
    height: 27.8485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.121071
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_201_600",
    x: -4.53614,
    y: 89.4826,
    width: 64.4341,
    height: 20.8536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.32694
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_201_600",
    x: -6.10605,
    y: 92.5731,
    width: 41.8955,
    height: 110.308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.05302
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_201_600",
    x: 28.8329,
    y: 99.8161,
    width: 27.2616,
    height: 97.8093,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.425227
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_201_600",
    x: 18.2356,
    y: 71.5943,
    width: 18.3458,
    height: 5.93748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.662531
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_b_201_600",
    x: 19.2851,
    y: 73.9706,
    width: 8.93582,
    height: 28.4143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.121071
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_b_201_600",
    x: 27.7365,
    y: 74.5366,
    width: 7.76199,
    height: 27.8485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.121071
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_b_201_600",
    x: 158.74,
    y: 151.668,
    width: 18.3458,
    height: 5.93748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.662531
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_b_201_600",
    x: 159.789,
    y: 154.044,
    width: 8.93581,
    height: 28.4143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.121071
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_b_201_600",
    x: 168.241,
    y: 154.61,
    width: 7.762,
    height: 27.8485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.121071
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_b_201_600",
    x: 135.968,
    y: 57.6498,
    width: 64.4341,
    height: 20.8536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.32694
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_b_201_600",
    x: 134.398,
    y: 60.7403,
    width: 41.8955,
    height: 110.308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.05302
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_b_201_600",
    x: 169.337,
    y: 67.9833,
    width: 27.2616,
    height: 97.8093,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.425227
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_b_201_600",
    x: 158.74,
    y: 39.7613,
    width: 18.3458,
    height: 5.93748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.662531
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_b_201_600",
    x: 159.789,
    y: 42.1376,
    width: 8.93581,
    height: 28.4143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.121071
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_b_201_600",
    x: 168.241,
    y: 42.7035,
    width: 7.762,
    height: 27.8485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.121071
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_b_201_600",
    x: 228.992,
    y: 183.501,
    width: 18.3458,
    height: 5.93748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.662531
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_b_201_600",
    x: 230.041,
    y: 185.877,
    width: 8.93582,
    height: 28.4143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.121071
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_b_201_600",
    x: 206.22,
    y: 34.5982,
    width: 64.4341,
    height: 20.8536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.32694
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_b_201_600",
    x: 204.65,
    y: 37.6886,
    width: 41.8955,
    height: 165.192,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.05302
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_b_201_600",
    x: 228.992,
    y: 16.7099,
    width: 18.3458,
    height: 5.93748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.662531
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_b_201_600",
    x: 230.041,
    y: 19.0862,
    width: 8.93582,
    height: 28.4143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.121071
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_b_201_600",
    x: 88.4877,
    y: 167.036,
    width: 18.3458,
    height: 5.93748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.662531
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_b_201_600",
    x: 89.5371,
    y: 169.412,
    width: 8.93581,
    height: 28.4143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.121071
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_b_201_600",
    x: 97.9886,
    y: 169.978,
    width: 7.762,
    height: 27.8485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.121071
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_b_201_600",
    x: 65.7159,
    y: 18.1329,
    width: 64.4341,
    height: 20.8536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.32694
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_b_201_600",
    x: 64.146,
    y: 21.2233,
    width: 41.8955,
    height: 165.192,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.05302
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_b_201_600",
    x: 99.085,
    y: 28.4663,
    width: 27.2616,
    height: 152.694,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.425227
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_b_201_600",
    x: 88.4877,
    y: 0.244579,
    width: 18.3458,
    height: 5.93748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.662531
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_b_201_600",
    x: 89.5371,
    y: 2.62083,
    width: 8.93581,
    height: 28.4143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.121071
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_b_201_600",
    x: 97.9886,
    y: 3.18687,
    width: 7.762,
    height: 27.8485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.121071
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_600",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_600",
    x1: 34.1832,
    y1: 187.898,
    x2: 24.0634,
    y2: 181.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.273487,
    stopColor: "#FCB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_201_600",
    x1: 28.1526,
    y1: 188.924,
    x2: 28.3887,
    y2: 183.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_201_600",
    x1: 28.0808,
    y1: 187.854,
    x2: 28.642,
    y2: 184.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_201_600",
    x1: 27.2215,
    y1: 210.846,
    x2: 14.2263,
    y2: 206.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_201_600",
    x1: 23.753,
    y1: 186.119,
    x2: 38.4954,
    y2: 209.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE2E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1149 210.414) rotate(-118.822) scale(6.12504 3.37509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_201_600",
    x1: 28.6307,
    y1: 210.91,
    x2: 40.0619,
    y2: 207.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_201_600",
    x1: 28.6307,
    y1: 210.91,
    x2: 40.0619,
    y2: 207.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_201_600",
    x1: 31.6175,
    y1: 183.151,
    x2: 14.0224,
    y2: 204.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.5836 210.028) rotate(-66.814) scale(6.4582 3.04934)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_201_600",
    x1: 51.4748,
    y1: 104.925,
    x2: 15.932,
    y2: 81.0711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.273487,
    stopColor: "#FCB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_201_600",
    x1: 30.2943,
    y1: 108.531,
    x2: 31.1235,
    y2: 90.4984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_201_600",
    x1: 30.042,
    y1: 104.771,
    x2: 32.0132,
    y2: 94.6403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_201_600",
    x1: 27.0238,
    y1: 185.523,
    x2: -18.618,
    y2: 170.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_201_600",
    x1: 14.8417,
    y1: 98.6791,
    x2: 66.62,
    y2: 179.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE2E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.1373 184.008) rotate(-118.822) scale(21.5124 11.854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_201_600",
    x1: 31.9736,
    y1: 185.751,
    x2: 72.1222,
    y2: 174.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_201_600",
    x1: 31.9736,
    y1: 185.751,
    x2: 72.1222,
    y2: 174.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_201_600",
    x1: 42.4638,
    y1: 88.254,
    x2: -19.3339,
    y2: 162.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.3203 182.651) rotate(-66.814) scale(22.6825 10.7099)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_201_600",
    x1: 34.1832,
    y1: 75.9912,
    x2: 24.0634,
    y2: 69.1994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.273487,
    stopColor: "#FCB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_201_600",
    x1: 28.1526,
    y1: 77.0179,
    x2: 28.3887,
    y2: 71.8836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_201_600",
    x1: 28.0808,
    y1: 75.9474,
    x2: 28.642,
    y2: 73.0628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_201_600",
    x1: 27.2215,
    y1: 98.9391,
    x2: 14.2263,
    y2: 94.7875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_201_600",
    x1: 23.753,
    y1: 74.2128,
    x2: 38.4954,
    y2: 97.0942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE2E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1149 98.5078) rotate(-118.822) scale(6.12504 3.37509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_201_600",
    x1: 28.6307,
    y1: 99.0042,
    x2: 40.0619,
    y2: 95.7944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_201_600",
    x1: 28.6307,
    y1: 99.0042,
    x2: 40.0619,
    y2: 95.7944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_201_600",
    x1: 31.6175,
    y1: 71.2447,
    x2: 14.0224,
    y2: 92.5017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.5836 98.1216) rotate(-66.814) scale(6.4582 3.04934)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_201_600",
    x1: 174.688,
    y1: 156.065,
    x2: 164.568,
    y2: 149.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.273487,
    stopColor: "#FCB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_201_600",
    x1: 168.657,
    y1: 157.091,
    x2: 168.893,
    y2: 151.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_201_600",
    x1: 168.585,
    y1: 156.021,
    x2: 169.147,
    y2: 153.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_201_600",
    x1: 167.726,
    y1: 179.013,
    x2: 154.731,
    y2: 174.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_201_600",
    x1: 164.257,
    y1: 154.286,
    x2: 179,
    y2: 177.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE2E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.619 178.581) rotate(-118.822) scale(6.12504 3.37509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_201_600",
    x1: 169.135,
    y1: 179.077,
    x2: 180.566,
    y2: 175.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_201_600",
    x1: 169.135,
    y1: 179.077,
    x2: 180.566,
    y2: 175.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_201_600",
    x1: 172.122,
    y1: 151.318,
    x2: 154.527,
    y2: 172.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.088 178.195) rotate(-66.814) scale(6.4582 3.04934)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_201_600",
    x1: 191.979,
    y1: 73.0924,
    x2: 156.436,
    y2: 49.2383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.273487,
    stopColor: "#FCB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_201_600",
    x1: 170.798,
    y1: 76.6985,
    x2: 171.628,
    y2: 58.6656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_201_600",
    x1: 170.546,
    y1: 72.9386,
    x2: 172.517,
    y2: 62.8075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_201_600",
    x1: 167.528,
    y1: 153.69,
    x2: 121.886,
    y2: 139.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_201_600",
    x1: 155.346,
    y1: 66.8463,
    x2: 207.124,
    y2: 147.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE2E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163.641 152.175) rotate(-118.822) scale(21.5124 11.854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_201_600",
    x1: 172.478,
    y1: 153.918,
    x2: 212.626,
    y2: 142.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_201_600",
    x1: 172.478,
    y1: 153.918,
    x2: 212.626,
    y2: 142.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_201_600",
    x1: 182.968,
    y1: 56.4212,
    x2: 121.17,
    y2: 131.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(175.824 150.818) rotate(-66.814) scale(22.6825 10.7099)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_201_600",
    x1: 174.688,
    y1: 44.1581,
    x2: 164.568,
    y2: 37.3663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.273487,
    stopColor: "#FCB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_201_600",
    x1: 168.657,
    y1: 45.1848,
    x2: 168.893,
    y2: 40.0505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_201_600",
    x1: 168.585,
    y1: 44.1143,
    x2: 169.147,
    y2: 41.2298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_201_600",
    x1: 167.726,
    y1: 67.1061,
    x2: 154.731,
    y2: 62.9544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_201_600",
    x1: 164.257,
    y1: 42.3797,
    x2: 179,
    y2: 65.2611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE2E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.619 66.6747) rotate(-118.822) scale(6.12504 3.37509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_201_600",
    x1: 169.135,
    y1: 67.1711,
    x2: 180.566,
    y2: 63.9613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_201_600",
    x1: 169.135,
    y1: 67.1711,
    x2: 180.566,
    y2: 63.9613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_201_600",
    x1: 172.122,
    y1: 39.4116,
    x2: 154.527,
    y2: 60.6686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.088 66.2885) rotate(-66.814) scale(6.4582 3.04934)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_201_600",
    x1: 244.939,
    y1: 187.898,
    x2: 234.819,
    y2: 181.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.273487,
    stopColor: "#FCB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_201_600",
    x1: 238.909,
    y1: 188.924,
    x2: 239.145,
    y2: 183.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_201_600",
    x1: 238.837,
    y1: 187.854,
    x2: 239.398,
    y2: 184.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CFF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_201_600",
    x1: 237.978,
    y1: 210.846,
    x2: 224.982,
    y2: 206.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CFF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084B19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_201_600",
    x1: 234.509,
    y1: 186.119,
    x2: 249.251,
    y2: 209.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(236.871 210.414) rotate(-118.822) scale(6.12504 3.37509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_201_600",
    x1: 262.231,
    y1: 50.0408,
    x2: 226.688,
    y2: 26.1867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.273487,
    stopColor: "#FCB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_201_600",
    x1: 241.05,
    y1: 53.6468,
    x2: 241.879,
    y2: 35.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_201_600",
    x1: 240.798,
    y1: 49.887,
    x2: 242.769,
    y2: 39.7558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CFF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_201_600",
    x1: 237.78,
    y1: 130.639,
    x2: 192.138,
    y2: 116.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CFF6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_201_600",
    x1: 225.598,
    y1: 43.7947,
    x2: 277.376,
    y2: 124.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(233.893 129.124) rotate(-118.822) scale(21.5124 11.854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_201_600",
    x1: 244.939,
    y1: 21.1067,
    x2: 234.819,
    y2: 14.3149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.273487,
    stopColor: "#FCB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_201_600",
    x1: 238.909,
    y1: 22.1334,
    x2: 239.145,
    y2: 16.9991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_201_600",
    x1: 238.837,
    y1: 21.0629,
    x2: 239.398,
    y2: 18.1784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CFF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_201_600",
    x1: 237.978,
    y1: 44.0547,
    x2: 224.982,
    y2: 39.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CFF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084B19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_201_600",
    x1: 234.509,
    y1: 19.3283,
    x2: 249.251,
    y2: 42.2097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(236.871 43.6233) rotate(-118.822) scale(6.12504 3.37509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_201_600",
    x1: 104.435,
    y1: 171.432,
    x2: 94.3154,
    y2: 164.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.273487,
    stopColor: "#FCB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_201_600",
    x1: 98.4047,
    y1: 172.459,
    x2: 98.6408,
    y2: 167.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_201_600",
    x1: 98.3328,
    y1: 171.389,
    x2: 98.8941,
    y2: 168.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CFF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_201_600",
    x1: 97.4736,
    y1: 194.38,
    x2: 84.4783,
    y2: 190.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CFF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084B19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_201_600",
    x1: 94.005,
    y1: 169.654,
    x2: 108.747,
    y2: 192.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.367 193.949) rotate(-118.822) scale(6.12504 3.37509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_201_600",
    x1: 98.8828,
    y1: 194.445,
    x2: 110.314,
    y2: 191.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_201_600",
    x1: 98.8828,
    y1: 194.445,
    x2: 110.314,
    y2: 191.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CFF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_201_600",
    x1: 101.87,
    y1: 166.686,
    x2: 84.2744,
    y2: 187.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.8357 193.563) rotate(-66.814) scale(6.4582 3.04934)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_201_600",
    x1: 121.727,
    y1: 33.5755,
    x2: 86.184,
    y2: 9.72136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.273487,
    stopColor: "#FCB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_201_600",
    x1: 100.546,
    y1: 37.1815,
    x2: 101.376,
    y2: 19.1487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_201_600",
    x1: 100.294,
    y1: 33.4217,
    x2: 102.265,
    y2: 23.2905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CFF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_201_600",
    x1: 97.2759,
    y1: 114.173,
    x2: 51.6341,
    y2: 99.5918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CFF6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_201_600",
    x1: 85.0938,
    y1: 27.3294,
    x2: 136.872,
    y2: 107.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.3893 112.658) rotate(-118.822) scale(21.5124 11.854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_201_600",
    x1: 102.226,
    y1: 114.401,
    x2: 142.374,
    y2: 103.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_201_600",
    x1: 102.226,
    y1: 114.401,
    x2: 142.374,
    y2: 103.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CFF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_201_600",
    x1: 112.716,
    y1: 16.9042,
    x2: 50.9182,
    y2: 91.5632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.572 111.301) rotate(-66.814) scale(22.6825 10.7099)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_201_600",
    x1: 104.435,
    y1: 4.64142,
    x2: 94.3154,
    y2: -2.15037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.273487,
    stopColor: "#FCB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_201_600",
    x1: 98.4047,
    y1: 5.66814,
    x2: 98.6408,
    y2: 0.533791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_201_600",
    x1: 98.3328,
    y1: 4.59763,
    x2: 98.8941,
    y2: 1.71306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CFF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#343434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_201_600",
    x1: 97.4736,
    y1: 27.5893,
    x2: 84.4783,
    y2: 23.4377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CFF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#084B19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_201_600",
    x1: 94.005,
    y1: 2.86298,
    x2: 108.747,
    y2: 25.7444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.367 27.158) rotate(-118.822) scale(6.12504 3.37509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_201_600",
    x1: 98.8828,
    y1: 27.6544,
    x2: 110.314,
    y2: 24.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_201_600",
    x1: 98.8828,
    y1: 27.6544,
    x2: 110.314,
    y2: 24.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CFF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_201_600",
    x1: 101.87,
    y1: -0.105103,
    x2: 84.2744,
    y2: 21.1519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_201_600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.8357 26.7719) rotate(-66.814) scale(6.4582 3.04934)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.24
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/Order.cca47374d233e017dd440ac3e8ed2cbb.svg";
export { ForwardRef as ReactComponent };